/* eslint import/no-extraneous-dependencies: off */
import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

export const setLdapGroups = createAsyncThunk("ldapGroups/setLdapGroups", async (inputData) => {
    let ldapGroups = [];
    if (inputData === null) {
        return null;
    }
    ldapGroups = inputData.json.person_ldap_group;

    if (inputData.newSearchText && inputData.newSearchText.length > 0 && ldapGroups && ldapGroups.length > 0) {
        const searchText = inputData.newSearchText.toLowerCase();
        return ldapGroups.filter((item) => Object.values(item).some((value) => String(value).toLowerCase()?.includes(searchText)));
    }
    return ldapGroups;
});

export const initialState = {
    ldap_group_id: "",
    operation_id: "",
    name: "",
    sam_account_name: "",
    distinguished_name: "",
    cn: "",
    object_sid: "",
    object_guid: ""
};

const ldapGroupsSlice = createSlice({
    name: "ldapGroups",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(setLdapGroups.fulfilled, (state, action) => action.payload);
    }
});

export const selectLdapGroups = ({ldapGroups}) => ldapGroups;

export default ldapGroupsSlice.reducer;
